const mountedElements = new WeakMap();

/**
 * Hydration re-runs slot processors on every project refresh: `bind` wires
 * an element only once per `key`. A new key replaces the previous binding,
 * whose cleanup `bind` returns.
 */
export const mountOnce = (element, key, bind) => {
  if (!element) return;
  const current = mountedElements.get(element);
  if (current && current.key === key) return;
  if (current && current.unbind) current.unbind();
  mountedElements.set(element, { key, unbind: bind() });
};
